<template>
  <div>
    <div class="message">Unauthorized</div>
    <div class="action"><button class="action-button" @click="onLoginClick">LOGIN</button></div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';

const router = useRouter();

function onLoginClick() {
  router.push({ name: 'login' });
}
</script>

<style>
  .message {
    margin-top: 20%;
    text-align: center;
    font-size: 3rem;
  }

  .action {
    margin-top: 10%;
    text-align: center;
  }

  .action-button {
    width: 50px;
    height: 40px;
  }

  @media only screen and (max-width: 430px) {
    .message {
      margin-top: 40%;
    }

    .action {
      position: fixed;
      bottom: 20px;
      text-align: unset;
      left: 50%;
      transform: translateX(-50%);
    }

    .action-button {
      width: 90%;
      height: 40px;
    }
  }
</style>
